import axios from 'axios';
import { client } from '@/services/api/axios.ts';
import { useQuery } from '@tanstack/react-query';
import { TUsers } from '@/features/users/schemas/users.schema.ts';

export async function getAllUsers(): Promise<TUsers | undefined | never> {
  try {
    const { data } = await client.get(`/users`);

    return data.body;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw new Error(`${error?.response?.data?.message}`);
    }

    if (error instanceof Error) {
      throw new Error(`${error.message}}`);
    }
  }
}

export const useGetUsersQuery = ({ enabled }: { enabled?: boolean } = { enabled: true }) => {
  return useQuery({
    queryKey: ['users'],
    queryFn: getAllUsers,
    retry: 1,
    enabled,
  });
};
